import { useEffect, useState } from 'react'

import { api, type Me } from '../../lib/api'
import { ErrorBox, Loading } from '../../components/DataTable'

// Who this tenant is.
//
// # WHY THERE ARE NO BUSINESS UNITS HERE ANY MORE
//
// Because a third party is engaged by the organisation, not by a department of
// it. Every vendor would have been filed under one unit, every report would
// have had to decide whether to sum across them, and the answer to "who owns
// this vendor" was already a named person on the vendor record. It added a
// mandatory question with no consequence, so it is gone.

export function OrganisationTab() {
  const [me, setMe] = useState<Me | null>(null)
  const [error, setError] = useState<unknown>(null)

  useEffect(() => {
    api.me().then(setMe).catch(setError)
  }, [])

  if (error != null) return <ErrorBox error={error} what="The organisation" />
  if (!me) return <Loading what="the organisation" />

  return (
    <div className="settings-stack">
      <section className="panel">
        <div className="p1-head">
          <div>
            <h2>Organisation</h2>
            <p className="obs-what">Who this tenant is, as the platform records it</p>
          </div>
        </div>
        <div className="p1-kv p1-kv-wide">
          <span>Name</span>
          <span>{me.tenant.displayName || me.tenant.legalName}</span>
          <span>Legal name</span>
          <span>{me.tenant.legalName}</span>
          <span>Data region</span>
          <span>{me.tenant.dataRegion ?? 'Not recorded'}</span>
          <span>Role in the law</span>
          <span>{me.processorRole === 'PROCESSOR' ? 'Processor' : 'Controller'}</span>
        </div>
      </section>
    </div>
  )
}
